const header = document.querySelector('.header');

/**
 * Set classes for header animation
 */
const { body } = document;
const scrollUp = 'scroll-up';
const scrollDown = 'scroll-down';
let lastScroll = 0;

window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 0) {
    body.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});

/**
 * Flyout
 */
if (header) {
  const headerFlyoutOpen = 'header--flyout-open';
  const headerFlyoutClosed = 'header--flyout-closed';
  const bodyFlyoutOpen = 'body--flyout-open';
  const buttonOpenFlyout = document.querySelector('.header__menu');
  const buttonCloseFlyout = document.querySelector('.header__flyout__close-button');
  const headerFlyout = document.querySelector('.header__flyout');

  // Toggle flyout
  const toggleFlyout = (event) => {
    if (body.classList.contains(bodyFlyoutOpen)) {
      body.classList.remove(bodyFlyoutOpen);
      header.classList.remove(headerFlyoutOpen);
      header.classList.add(headerFlyoutClosed);
      buttonOpenFlyout.setAttribute('aria-expanded', false);
    } else {
      body.classList.add(bodyFlyoutOpen);
      header.classList.add(headerFlyoutOpen);
      header.classList.remove(headerFlyoutClosed);
      buttonOpenFlyout.setAttribute('aria-expanded', true);
    }
    event.stopPropagation();
    return false;
  };
  buttonOpenFlyout.addEventListener('click', toggleFlyout);
  // buttonOpenFlyout.addEventListener('mouseover', openFlyout);

  // Close flyout
  const closeFLyout = () => {
    body.classList.remove(bodyFlyoutOpen);
    header.classList.remove(headerFlyoutOpen);
    header.classList.add(headerFlyoutClosed);
    buttonCloseFlyout.removeAttribute('aria-expanded', header.classList.contains(headerFlyoutOpen));
  };
  buttonCloseFlyout.addEventListener('click', closeFLyout);

  // Close flyout on click outside
  const clickOutside = (event) => {
    const isClickInside = headerFlyout.contains(event.target);
    if (!isClickInside) {
      body.classList.remove(bodyFlyoutOpen);
      header.classList.remove(headerFlyoutOpen);
      header.classList.add(headerFlyoutClosed);
      buttonCloseFlyout.removeAttribute('aria-expanded', header.classList.contains(headerFlyoutOpen));
    }
  };
  document.addEventListener('click', clickOutside);
}

/**
 * Mobile menu
 */
if (header) {
  const headerMenuOpen = 'header--mobile-menu-open';
  const bodyMenuOpen = 'body--mobile-menu-open';
  const buttonOpenMenu = document.querySelector('.header__toggle__button');
  const buttonCloseMenu = document.querySelector('.header__mobile-menu__toggle__button');

  // Open mobile menu
  const openMenu = () => {
    body.classList.add(bodyMenuOpen);
    header.classList.add(headerMenuOpen);
    buttonOpenMenu.setAttribute('aria-expanded', header.classList.contains(headerMenuOpen));
  };
  buttonOpenMenu.addEventListener('click', openMenu);

  // Close mobile menu
  const closeMenu = () => {
    body.classList.remove(bodyMenuOpen);
    header.classList.remove(headerMenuOpen);
    buttonCloseMenu.removeAttribute('aria-expanded', header.classList.contains(headerMenuOpen));
  };
  buttonCloseMenu.addEventListener('click', closeMenu);


  // Level 2
  const mobileMenu = document.querySelector('.header__mobile-menu');
  const mobileMenuHeightTarget = document.querySelector('.header__mobile-menu__main__inner');
  const mobileMenuLevel2Visible = 'header__mobile-menu--level2-visible';
  const mobileMenuLevel1Button = document.querySelectorAll('.header__mobile-menu__level1__button');
  const mobileMenuLevel2Title = document.querySelectorAll('.header__mobile-menu__level2__title-button');
  const mobileMenuLevel2Back = document.querySelector('.header__mobile-menu__back');
  let mobileMenuCurrentLevel2 = null;

  // Update container height
  const updateLevel2ContainerHeight = () => {
    if (mobileMenuCurrentLevel2) {
      const { height } = mobileMenuCurrentLevel2.getBoundingClientRect();
      mobileMenuHeightTarget.style.height = `${height}px`;
    } else {
      mobileMenuHeightTarget.style.height = null;
    }
  };
  window.addEventListener('resize', updateLevel2ContainerHeight);

  // Show level 2 in mobile menu
  const showLevel2 = (e) => {
    mobileMenu.classList.add(mobileMenuLevel2Visible);

    const target = e.currentTarget;
    const mobileMenuLevel1Active = document.querySelector('.header__mobile-menu__level1__button--active');
    const activeClass = 'header__mobile-menu__level1__button--active';
    e.preventDefault();
    if (mobileMenuLevel1Active) {
      mobileMenuLevel1Active.classList.remove(activeClass);
    }
    mobileMenuCurrentLevel2 = target.closest('li').querySelector('ul');
    target.classList.add(activeClass);
    updateLevel2ContainerHeight();
  };
  mobileMenuLevel1Button.forEach(button => button.addEventListener('click', showLevel2));

  // Hide level 2 in mobile menu
  const hideLevel2 = () => {
    mobileMenu.classList.remove(mobileMenuLevel2Visible);
    mobileMenuCurrentLevel2 = null;
    updateLevel2ContainerHeight();
  };
  mobileMenuLevel2Title.forEach(button => button.addEventListener('click', hideLevel2));
  mobileMenuLevel2Back.addEventListener('click', hideLevel2);
  buttonCloseMenu.addEventListener('click', hideLevel2);
}
